<script>
	import { Button, Col, Row } from "sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import CarParkOwnerTable from "./CarParkOwnerTable.svelte";
	import { form, field } from "svelte-forms";
	import { onMount, onDestroy } from "svelte";
	import { handleCsvImport } from "src/utils/misc";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		initPage,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(
				`/v1/carParks/owners/filter?Page=${$initPage}&Size=50`,
				{
					method: "GET",
					version: "Vehicle",
				}
			);
			data = res?.data?.dataList;
			totalPages.set(res?.data?.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);
			extractErrorMessage(err);
		}
	});

	const refreshData = async (type) => {
		try {
			if (type == "delete") {
				loading.set(true);
			} else {
				loadingStatus.set(true);
			}
			const res = await client(
				`/v1/carParks/owners/filter?Page=${$initPage}&Size=50`,
				{
					method: "GET",
					version: "Vehicle",
				}
			);
			data = res?.data?.dataList;
			totalPages.set(res?.data?.totalPage);
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
		} catch (err) {
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
			extractErrorMessage(err);
			console.log(err);
		}
	};

	let data = [];
	let carParkOwnerError;
	const carParkOwner = field("carParkOwner", "", [required()]);
	const myForm = form(carParkOwner);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/carParks/owners", {
				method: "POST",
				version: "Vehicle",
				data: {
					name: $carParkOwner.value,
				},
			});

			if (res?.status === 200) {
				refreshData();
				loading.set(false);
			} else {
				loading.set(false);
				carParkOwnerError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			carParkOwnerError = error.response.data.message;
			loading.set(false);
		}
	};

	let idStatus;
	async function handleStatusChange(id, status) {
		idStatus = id;
		try {
			loadingStatus.set(true);
			const res = await client("/v1/carParks/owners/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id,
					status,
				},
			});
			if (res?.status === 200) {
				refreshData();
			}
		} catch (err) {
			console.log(err);
			loadingStatus.set(false);
			extractErrorMessage(err);
		}
	}

	async function handleDelete(id) {
		idStatus = id;
		try {
			loading.set(true);
			const res = await client(`/v1/carParks/owners/${id}`, {
				method: "DELETE",
				version: "Vehicle",
			});
			if (res?.status === 200) {
				refreshData("delete");
			} else if (res?.status === 400) {
				errorMessage.set(res.data.message);
			}

			loading.set(false);
		} catch (err) {
			console.log(err);
			loading.set(false);
			extractErrorMessage(err);
		}
	}

	const handleDownloadCSV = async () => {
		try {
			const res = await client("/v1/carParks/owners/csvFileExport", {
				method: "GET",
				version: "Vehicle",
				// header: "csv",
			});

			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "carpark_owner_Template.csv"); //or any other extension
			document.body.appendChild(link);
			link.click();

			// ;
		} catch (err) {
			console.log(err);
			extractErrorMessage(err);
		}
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	onDestroy(() => {
		initPage.set(1);
	});
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Carpark Owner Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Add Carpark Owner</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span> Carpark owner name* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carParkOwner.value}
						error={$myForm.hasError("carParkOwner.required") ||
							carParkOwnerError}
						errorText={$myForm.hasError("carParkOwner.required")
							? "Carpark owner name is required"
							: carParkOwnerError
							? carParkOwnerError
							: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carParkOwner.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Add
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
	<Col class="d-flex justify-content-end" xs={6}>
		<div class="mx-4 text-center">
			<Row>
				<input
					id="fileInput"
					type="file"
					multiple={false}
					hidden="hidden"
					on:change={(e) =>
						handleCsvImport(
							e,
							"/v1/carParks/owners/csvFileImport",
							"Vehicle"
						)}
				/>
				<label
					type="button"
					for="fileInput"
					id="customButton"
					class="btn themeButton primary px-4 btn"
					block>Import CSV</label
				>
			</Row>
			<Row>
				<p>
					<a
						href="/assets/csv/carpark_owner_Template.csv"
						target="_blank"
						download="carpark_owner_template.csv"
						rel="noreferrer"
						class="link link-text"
					>
						Download CSV Template
					</a>
				</p>
			</Row>
		</div>
	</Col>
	<!-- <Col xs={12} class="mt-4">
        <div class="line mt-4" />
    </Col> -->

	<Col class="my-5">
		<ErrorMessageHandler message={err} />
		<CarParkOwnerTable
			{data}
			{handleStatusChange}
			{idStatus}
			{handleDelete}
		/>
	</Col>
</Row>

<!-- <style>
	.line {
		width: 100%;
		border: 1px solid #f0eaea;
		display: inline-block;
	}
</style> -->
